export default "__VITE_IMAGE_ASSET__a5447c4c__";